// Move Shopify Pay banner to a dive just before the product's price
$("shopify-payment-terms").insertBefore(".stamped-product-reviews-badge");
$("shopify-payment-terms").before("<div id='shopify-pay-banner-div'></div>");
$("shopify-payment-terms").prependTo($("#shopify-pay-banner-div"));

// Add margin to the created div
$("#shopify-pay-banner-div").css({
  "margin-top": "30px",
  "margin-bottom": "-25px",
});
